/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';
import {Router} from "@angular/router";

import {AuthenticationService} from './authentication.service';
import {BaseService} from "./base-service";

import {ServerObject} from '../models/server-object';
import {ServerObjectInstance} from '../models/server-object-instance';
import { PagedResults } from 'app/models/paged-results';
import { RestService } from './rest-service';
import { Url_Base } from 'app/rest-constants';


@Injectable()
export class ServerObjectService extends BaseService {


  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService
  ) {
    super(router, authenticationService);
  }

  private getUrl(): string {
    return `${Url_Base}/server-objects/`;
  }

  getNumberServerObjects(): Promise<Number> {
    const callUrl = this.getUrl() + 'count';
    return this.mRestService.get<Number>(callUrl);
  }

  getNumberServerObjectInstances(): Promise<Number> {
    const callUrl = this.getUrl() + 'instances/count';
    return this.mRestService.get<Number>(callUrl);
  }

  getAllServerObjectsForPaging(start: number, size: number, order: String, filterString: String): Promise<PagedResults<ServerObject>> {
    const callUrl = this.getUrl() + 'paging?start=' + start + "&size=" + size + "&order=ASC" + "&filterColumn=name&filterString=" + filterString;

    console.log("Called URL: " + callUrl);
    return this.mRestService.get<PagedResults<ServerObject>>(callUrl);
  }

  getAllServerObjectInstancesForPaging(start: number, size: number, order: String, filterString: String): Promise<PagedResults<ServerObjectInstance>> {
    const callUrl = this.getUrl() + 'instances/paging?start=' + start + "&size=" + size + "&order=ASC&filterColumn=name&filterString=" + filterString;

    return this.mRestService.get<PagedResults<ServerObjectInstance>>(callUrl);
  }

  getAllServerObjects(): Promise<ServerObject[]> {
    const callUrl = this.getUrl();
    return this.mRestService.get<ServerObject[]>(callUrl);
  }

  getServerObjectById(id: number): Promise<ServerObject> {
    const callUrl = this.getUrl() + `${id}`;
    return this.mRestService.get<ServerObject>(callUrl);
  }

  createServerObject(serverObject: ServerObject): Promise<ServerObject> {
    const callUrl = this.getUrl();
    return this.mRestService.post<ServerObject>(callUrl, serverObject);
  }

  updateServerObject(serverObject: ServerObject): Promise<ServerObject> {
    const callUrl = this.getUrl();
    return this.mRestService.put<ServerObject>(callUrl, serverObject);
  }

  deleteServerObjects(ids: number[]): Promise<any> {
    const callUrl = this.getUrl();
    return this.mRestService.delete(callUrl, ids);
  }






  getAllServerObjectInstances(): Promise<ServerObjectInstance[]> {
    const callUrl = this.getUrl() + 'instances';
    return this.mRestService.get<ServerObjectInstance[]>(callUrl);
  }

  getServerObjectInstancesFiltered(start: number, size: number, order: string, filterString: string): Promise<ServerObjectInstance[]> {
    const url = this.getUrl() + `instances/filtered?start=` + start + "&size=" + size + "&order=" + order + "&filterColumn=name&filterString=" + filterString;
    return this.mRestService.get<ServerObjectInstance[]>(url);
  } 

  getServerObjectInstanceById(id: number): Promise<ServerObjectInstance> {
    const callUrl = this.getUrl() + `instances/${id}`;
    return this.mRestService.get<ServerObjectInstance>(callUrl);
  }

  createServerObjectInstance(serverObjectInstance: ServerObjectInstance): Promise<ServerObjectInstance> {
    const callUrl = this.getUrl() + 'instances';
    return this.mRestService.post<ServerObjectInstance>(callUrl, serverObjectInstance);
  }

  updateServerObjectInstance(serverObjectInstance: ServerObjectInstance): Promise<ServerObjectInstance> {
    const callUrl = this.getUrl() + 'instances';
    return this.mRestService.put<ServerObjectInstance>(callUrl, serverObjectInstance);
  }

  deleteServerObjectInstances(ids: number[]): Promise<any> {
    const callUrl = this.getUrl() + `instances`;
    return this.mRestService.delete(callUrl, ids)
      .then(response => { return null; });
  }

}
